import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text text--h7 text--negative"
}

import TimesSvg from '../assets/times.svg';
import ArrowLeftSvg from '../assets/arrow-left.svg';

// Components
import VPanelRow from './VPanelRow.vue';
import VInfoList from './VInfoList.vue';
import VInfoItem from './VInfoItem.vue';
import VTextarea from './VTextarea.vue';
import VInput from './VInput.vue';
import VButton from './VButton.vue';

// Other
import INumericCounter from '@/core/Models/INumericCounter';
import { PropType, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import INumeric from '@/core/Models/INumeric';
import { INumericQuarterCompletion } from '@/mixins/NumericApi';
import { DateTime } from 'luxon';


export default /*@__PURE__*/_defineComponent({
  __name: 'VNumericCounterValueControl',
  props: {
    quarter: { type: Number, required: true },
    quarterCompletion: { type: Object as PropType<INumericQuarterCompletion>, required: true },
    actualValue: { type: Number, default: 0 },
    expectedValue: { type: Number, default: 0 },
    numeric: { type: Object as PropType<INumeric>, required: true },
    counter: { type: Object as PropType<INumericCounter>, required: true },
    counterDivisor: { type: [Object, null] as PropType<INumericCounter | undefined | null>, required: true },
},
  emits: ['submit', 'close'],
  setup(__props, { emit: __emit }) {

// Svg
const { t } = useI18n();
const emit = __emit;

const props = __props;

let counterValue = ref<number | null>(null);
let counterDivisorValue = ref<number | null>(null);

async function submit() {
    const result = [];

    let date = DateTime.utc();

    var maxDate = DateTime.utc()
        .set({ year: props.numeric.year, month: (props.quarter - 1) * 3 + 1 })
        .endOf('quarter');
    if (date > maxDate) {
        date = maxDate;
    }

    var minDate = DateTime.utc()
        .set({ year: props.numeric.year, month: (props.quarter - 1) * 3 + 1 })
        .startOf('quarter');
    if (date < minDate) {
        date = minDate;
    }

    if (counterValue.value !== null && counterValue.value !== undefined) {
        result.push({
            counterId: props.counter.id,
            value: counterValue.value,
            tagName: props.numeric.counterTagName,
            tagValue: props.numeric.counterTagValue,
            date,
        });
    }

    if (props.counterDivisor && counterDivisorValue.value) {
        result.push({
            counterId: props.counterDivisor.id,
            value: counterDivisorValue.value,
            tagName: props.numeric.counterDivisorTagName,
            tagValue: props.numeric.counterDivisorTagValue,
            date,
        });
    }

    if (result.length) {
        emit('submit', result);
    }
    emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(VPanelRow, null, {
      default: _withCtx(() => [
        _createVNode(VTextarea, {
          class: "simple-textarea--h2",
          disabled: "",
          maxlength: "255",
          "model-value": `${__props.numeric.name} (${_unref(t)('quarter' + __props.quarter)})`
        }, null, 8, ["model-value"])
      ]),
      _: 1
    }),
    _createVNode(VPanelRow, {
      padding: "",
      separate: ""
    }, {
      default: _withCtx(() => [
        _createVNode(VInfoList, { class: "numeric-panel__info-list" }, {
          default: _withCtx(() => [
            _createVNode(VInfoItem, {
              center: "",
              label: _unref(t)('numeric.expected-value')
            }, {
              default: _withCtx(() => [
                _createVNode(VInput, {
                  class: "input-field--primary",
                  disabled: "",
                  "model-value": __props.expectedValue,
                  numeric: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(VInfoItem, {
              center: "",
              label: _unref(t)('numeric.actual-value')
            }, {
              default: _withCtx(() => [
                _createVNode(VInput, {
                  class: "input-field--primary",
                  disabled: "",
                  "model-value": __props.actualValue,
                  numeric: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(VInfoItem, {
              center: "",
              label: _unref(t)('numeric.completion')
            }, {
              default: _withCtx(() => [
                _createVNode(VInput, {
                  class: "input-field--primary",
                  disabled: "",
                  "model-value": __props.quarterCompletion.value
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(VInfoItem, {
              center: "",
              label: _unref(t)('numeric-counter.units')
            }, {
              default: _withCtx(() => [
                _createVNode(VInput, {
                  class: "input-field--primary",
                  disabled: "",
                  "model-value": 
                        __props.counter && __props.counterDivisor && __props.counter.units != __props.counterDivisor.units
                            ? __props.counter.units + ', ' + __props.counterDivisor.units
                            : __props.counter.units
                    
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"]),
            (
                    __props.numeric.counter?.units &&
                    __props.numeric.counterDivisor?.units &&
                    __props.numeric.counter.units.toLowerCase() !== __props.numeric.counterDivisor.units.toLowerCase()
                )
              ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(_unref(t)('numeric-counter.units-not-match-description')), 1))
              : _createCommentVNode("", true),
            _createVNode(VInfoItem, {
              center: "",
              label: _unref(t)('numeric.condition')
            }, {
              default: _withCtx(() => [
                _createVNode(VInput, {
                  class: "input-field--primary",
                  disabled: "",
                  "model-value": _unref(t)('numeric.condition-' + __props.numeric.condition),
                  numeric: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(VPanelRow, {
      label: __props.counter.name,
      "label-separate": "",
      padding: "",
      separate: ""
    }, {
      default: _withCtx(() => [
        _createVNode(VInput, {
          modelValue: _unref(counterValue),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(counterValue) ? (counterValue).value = $event : counterValue = $event)),
          class: "input-field--primary inline-50-x inline-fluid",
          numeric: "",
          placeholder: _unref(t)('no-value')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["label"]),
    (__props.counterDivisor)
      ? (_openBlock(), _createBlock(VPanelRow, {
          key: 0,
          label: __props.counterDivisor.name,
          "label-separate": "",
          padding: "",
          separate: ""
        }, {
          default: _withCtx(() => [
            _createVNode(VInput, {
              modelValue: _unref(counterDivisorValue),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(counterDivisorValue) ? (counterDivisorValue).value = $event : counterDivisorValue = $event)),
              class: "input-field--primary inline-50-x inline-fluid",
              numeric: "",
              placeholder: _unref(t)('no-value')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]))
      : _createCommentVNode("", true),
    _createVNode(VPanelRow, {
      down: "",
      end: "",
      gap: "",
      padding: "",
      "separate-bottom": ""
    }, {
      default: _withCtx(() => [
        _createVNode(VButton, {
          class: "button--primary button--negative button--vcenter",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('cancel')) + " ", 1),
            _createVNode(_unref(TimesSvg))
          ]),
          _: 1
        }),
        _createVNode(VButton, {
          class: "button--primary button--green button--vcenter",
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('add-value')) + " ", 1),
            _createVNode(_unref(ArrowLeftSvg), { class: "rotate-180" })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})